<template>
  <genetic-nav current="home">
    <template #mainContent>
      <a-page-header
          style="border: 1px solid rgb(235, 237, 240)"
          :title="$t('taskList')"
      >
        <template #extra>
          <create-new-task @createSuccess="initPage"></create-new-task>
        </template>
        <task-search @changeSearch="changeSearch"></task-search>
      </a-page-header>
      <v-page :total="page.total" :order-list="orderList" @pageChange="changePage"></v-page>
      <a-table :columns="cols" :data-source="taskList" :pagination="false">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            {{ index + 1 }}
          </template>
          <template v-if="column.key === 'animaltype'">
            <option-tag :option-list="animalTypeList" :option-val="record.animaltype"></option-tag>
          </template>
          <template v-if="column.key === 'edittype'">
            <option-tag :option-list="editTypeList" :option-val="record.edittype"></option-tag>
            <a-tag color="#108ee9" v-if="record.edittype === '07'">{{ record.otheredit }}</a-tag>
          </template>
          <template v-if="column.key === 'belonguser'">
            {{ record.userName }}
          </template>
          <template v-if="column.key === 'createtime'">
            {{ formatDate(record.createtime) }}
          </template>
          <template v-if="column.key === 'description'">
            <div style="word-break: break-all">
              {{ record.description }}
            </div>
          </template>
          <template v-if="column.key === 'status'">
            <a-tag color="#f50" v-if="record.completestatus === '91'">{{ $t("quit") }}</a-tag>
            <template v-else>
              <div style="text-align: center;line-height: 1;display: inline-block">
                <option-tag :option-list="statusList" :option-val=" '0' + (parseInt(record.status) - 1)" icon="complete"></option-tag>
                <iron-icon v-if="parseInt(record.status) > 0 && parseInt(record.status) < 8" />
                <option-tag v-if="parseInt(record.status) < 8" :option-list="statusList" :option-val="record.status" icon="processing"></option-tag>
<!--                <iron-icon v-if="parseInt(record.status) < 6"/>-->
<!--                <option-tag  v-if="parseInt(record.status) < 6" :option-list="statusList" :option-val=" '0' + (parseInt(record.status) + 1)" icon="waiting"></option-tag>-->
              </div>
            </template>
          </template>
          <template v-if="column.key === 'operation'">
            <task-detail :task-id="record.id" @changeStatus="initPage"></task-detail>
            <a-dropdown>
              <a class="ant-dropdown-link" @click.prevent>
                <a-button size="small">{{ $t("other") }}</a-button>
              </a>
              <template #overlay>
                <a-menu>
                  <edit-task :task-id="record.id" @editSuccess="initPage"></edit-task>
                  <a-menu-item :disabled="!canEdit(record)" @click="deleteTask(record.id)">
                    <a href="javascript:;">{{ $t("delete") }}</a>
                  </a-menu-item>
                  <a-menu-item v-if="isAdmin" @click="quitTask(record.id)">
                    <a href="javascript:;">{{ $t("quit") }}</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </template>
      </a-table>
    </template>
  </genetic-nav>
  <v-loading :show="loading"></v-loading>
  <front-confirm/>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/12 14:21
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import GeneticNav from "@/components/public/geneticNav";
import CreateNewTask from "@/components/task/createNewTask";
import TaskSearch from "@/components/task/taskSearch";
import VPage from "@/components/public/v-page";
import OptionTag from "@/components/public/optionTag";
import TaskDetail from "@/components/task/taskDetail";
import EditTask from "@/components/task/editTask";
import FrontConfirm from "@/components/public/frontConfirm.vue";
import {Modal} from 'ant-design-vue';
import {createVNode} from 'vue'
import {ExclamationCircleOutlined} from '@ant-design/icons-vue';
import IronIcon from "@/components/public/ironIcon.vue";

export default {
  name: "geneticHome",
  components: {
    IronIcon,
    FrontConfirm, EditTask, TaskDetail, OptionTag, VPage, TaskSearch, CreateNewTask, GeneticNav, VLoading},
  data() {
    return {
      loading: false,
      cols: [],
      taskList: [],
      page: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100', '500', '99999'],
        sortType: "back",
        order: "",
      },
      search: {},
      searchFlag: "reset"
    }
  },
  mounted() {
    this.initPage();
    this.initCols();
    console.log(encodeURIComponent(util.localUrl))
  },
  methods: {
    canEdit(task) {
      if (this.$store.getters.isCurrentUser(task.belonguser) && task.status === "00") {
        return true;
      }
      if (this.$store.getters.isGeneticAdmin) {
        return true;
      }
      return false;
    },
    deleteTask(taskId) {
      Modal.confirm({
        title: 'Are you sure delete this order?',
        icon: createVNode(ExclamationCircleOutlined),
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          var post = {
            taskId: taskId
          }
          util.$post("/task/list/deleteTask", post, () => {
            util.deleteSuccess();
            this.initPage();
          }, this.showMask, this.hideMask);
        },

      });

    },
    quitTask(taskId){
      console.log(taskId)
      Modal.confirm({
        title: 'Are you sure quit this order?',
        icon: createVNode(ExclamationCircleOutlined),
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          var post = {
            taskId: taskId
          }
          util.$post("/task/list/quitTask", post, () => {
            util.deleteSuccess();
            this.initPage();
          }, this.showMask, this.hideMask);
        },

      });
    },
    formatDate(val) {
      return util.dateFormat(val, "YYYY-MM-DD")
    },
    changeSearch(search, type) {
      this.search = search;
      this.page.current = 1;
      this.page.pageSize = 10;
      this.searchFlag = type;
      // this.initPage();
      if (this.searchFlag === "reset"){
        this.initPage();
      }else {
        this.searchAll();
      }
    },
    changePage(page) {
      this.page = page;
      if (this.searchFlag === "reset"){
        this.initPage();
      }else {
        this.searchAll();
      }
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    searchAll(){
      var post = {
        page: JSON.stringify(this.page),
        search: JSON.stringify(this.search)
      }
      util.$post("/task/list/searchAll", post, (res) => {
        this.taskList = res.taskList;
        this.page.total = res.total;
      }, this.showMask, this.hideMask);
    },
    initPage() {
      var post = {
        page: JSON.stringify(this.page),
        search: JSON.stringify(this.search)
      }
      util.$post("/task/list/initPage", post, (res) => {
        this.taskList = res.taskList;
        this.page.total = res.total;
      }, this.showMask, this.hideMask);
    },
    initCols() {
      var cols = new Array();

      cols.push({
        title: '#',
        dataIndex: 'index',
        key: 'index',
        width: 70
      })

      cols.push({
        title: this.$t("animalType"),
        dataIndex: 'animaltype',
        key: 'animaltype',
        width: "8%"
      })

      cols.push({
        title: this.$t("taskIndex"),
        dataIndex: 'taskindex',
        key: 'taskindex',
        width: "10%"
      })

      cols.push({
        title: this.$t("geneName"),
        dataIndex: 'genename',
        key: 'genename',
        width: "10%"
      })

      cols.push({
        title: this.$t("editType"),
        dataIndex: 'edittype',
        key: 'edittype',
        width: "10%"
      })

      cols.push({
        title: this.$t("description"),
        dataIndex: 'description',
        key: 'description',
      })

      cols.push({
        title: this.$t("belongUser"),
        dataIndex: 'belonguser',
        key: 'belonguser',
        width: "15%"
      })

      cols.push({
        title: this.$t("createTime"),
        dataIndex: 'createtime',
        key: 'createtime',
        width: "10%"
      })

      cols.push({
        title: this.$t("status"),
        dataIndex: 'status',
        key: 'status',
        width: "10%"
      })

      cols.push({
        title: this.$t("operation"),
        dataIndex: 'operation',
        key: 'operation',
        width: 70
      })


      this.cols = cols;
    }
  },
  computed: {
    isAdmin(){
      return this.$store.getters.isGeneticAdmin;
    },
    orderList() {
      return [
        {key: "animaltype", name: this.$t("animalType")},
        {key: "genename", name: this.$t("geneName")},
        {key: "edittype", name: this.$t("editType")},
        {key: "status", name: this.$t("status")},
        {key: "createtime", name: this.$t("createTime")},
      ]
    },
    statusList() {
      return util.statusList()
    },
    editTypeList() {
      return util.editTypeList();
    },
    animalTypeList() {
      return util.animalTypeList();
    }
  }
}
</script>

<style scoped>
button {
  margin: 3px 3px;
}
</style>